/**
 * This helper contains functions that assist with localization work needed in both the country detection helper and
 * translations helper
 */
const stringTemplateHelper = {
  /**
   * Takes in a translation string template and injects the correct value into the template
   *
   * @param inputString
   * @param replacements
   * @returns
   *
   *   InputString = This is a %{test} replacements = {test: 'essai'} => This is a essai
   */
  injectValueToTranslationStringTemplate(inputString: string, replacements: Record<string, any>) {
    for (const stringKey in replacements) {
      const stringValue = replacements[stringKey];
      // Regex on matching string injection format (e.g %{alternate}, demo: https://regexr.com/6ub7b)
      inputString = inputString.replaceAll(new RegExp(`%{${stringKey}}`, 'gm'), stringValue);
    }
    return inputString;
  },
};

export default stringTemplateHelper;
